import { call, put, takeEvery } from "redux-saga/effects"

import { GET_NOTES, ADD_NEW_NOTE, UPDATE_NOTE, DELETE_NOTE } from "./actionTypes";
import {
    getNotesSuccess,
    getNotesFail,
    addNoteSuccess,
    addNoteFail,
    updateNoteSuccess,
    updateNoteFail,
    deleteNoteSuccess,
    deleteNoteFail,
   
} from "./actions"

import {
    getNotes,
    addNewNote,
    updateNote,
    deleteNote,
   
} from "helpers/notes/notes_backend_helper";
import { toast } from "react-toastify";

function* fetchNotes() {
    try {
        const response = yield call(getNotes)

        yield put(getNotesSuccess(response))
    } catch (error) {
        yield put(getNotesFail(error))
    }
}

function* onAddNewNote({ payload }) {
    try {

        
        const response = yield call(addNewNote, payload)

        console.log("RESPONSE:", response);
        yield put(addNoteSuccess(response.note))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addNoteFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateNote({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateNote, payload)
        yield put(updateNoteSuccess(response.note))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateNoteFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteNote({ payload: data }) {

    try {
        const response = yield call(deleteNote, data)
        yield put(deleteNoteSuccess(response.noteId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteNoteFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* noteSaga() {
    yield takeEvery(GET_NOTES, fetchNotes)
    yield takeEvery(ADD_NEW_NOTE, onAddNewNote)
    yield takeEvery(UPDATE_NOTE, onUpdateNote)
    yield takeEvery(DELETE_NOTE, onDeleteNote)
}

export default noteSaga;